import React from 'react';

import { MenuItem } from '@blueprintjs/core';
import { ItemPredicate, ItemRenderer, MultiSelect } from '@blueprintjs/select';

import { RoleField } from '../../styled';
import { toggleRole } from '../../utils/teamHealth';

// The page owns the selection, so it is kept across the Monthly, Weekly and Quarterly views
export interface RoleSelectionProps {
    selectedRoles: string[];
    onSelectedRolesChange: (roles: string[]) => void;
}

export interface RoleFilterProps extends RoleSelectionProps {
    roles: string[];
}

const matchesQuery: ItemPredicate<string> = (query, role) => role.toLowerCase().includes(query.trim().toLowerCase());

// Every change applies and is remembered at once; there is no Save step. No role chosen is All User Roles
const RoleFilter: React.FC<RoleFilterProps> = ({ roles, selectedRoles, onSelectedRolesChange }) => {
    const renderRole: ItemRenderer<string> = (role, { handleClick, handleFocus, modifiers, ref }) => (
        <MenuItem
            key={role}
            ref={ref}
            text={role}
            roleStructure="listoption"
            selected={selectedRoles.includes(role)}
            active={modifiers.active}
            disabled={modifiers.disabled}
            shouldDismissPopover={false}
            onClick={handleClick}
            onFocus={handleFocus}
        />
    );

    return (
        <RoleField>
            <label htmlFor="team-health-role">Role</label>
            <MultiSelect<string>
                fill
                resetOnSelect
                placeholder="All User Roles"
                items={roles}
                selectedItems={selectedRoles}
                itemPredicate={matchesQuery}
                itemRenderer={renderRole}
                tagRenderer={(role) => role}
                noResults={<MenuItem disabled roleStructure="listoption" text="No matching roles." />}
                tagInputProps={{ inputProps: { id: 'team-health-role' } }}
                popoverProps={{ minimal: true }}
                onItemSelect={(role) => onSelectedRolesChange(toggleRole(selectedRoles, role))}
                onRemove={(role) => onSelectedRolesChange(selectedRoles.filter((selected) => selected !== role))}
                onClear={() => onSelectedRolesChange([])}
            />
        </RoleField>
    );
};

export default RoleFilter;
